module.controller('getBankCtrl', ['$scope', '$state', '$http', '$stateParams', 'baseURI', 'Session', 'cacheService', 'OVERLAY',
  function ($scope, $state, $http, $stateParams, baseURI, Session, cacheService, OVERLAY){
    var bankId = $stateParams.bankId;
    $scope.overlay = OVERLAY['member.home.bank/detail'];
    $http.get(baseURI + 'bank/' + bankId).then(function (resp){
      $scope.bank = resp.data.Data;
    }).catch(function(){
      // alert('Unable to connect to ' + $scope.brand.programName);
    });


    $scope.removeBank = function(){
      $http.delete(baseURI + 'bank/' + bankId).then(function (data){
        cacheService.clear('bank');
        $state.go('member.home.transfers/manage.list');
      });
    };
  }]);
